// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__07Y1Z","noDynPadd":"Section_noDynPadd__ywPwJ"};